type TourDateItineraryInput = {
  packageNeoId: string;
  neoTourDate: string;
  locale: string;
  marketId: string;
};

const fetchTourDateItinerary = async (
  input: TourDateItineraryInput
): Promise<{ documentUrl: string }> => {
  const response = await fetch("/api/pdp/tour-date-itinerary", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input)
  });

  if (!response.ok) {
    throw new Error(`Error ${response.status}: ${response.statusText}`);
  }

  return response.json();
};

export default fetchTourDateItinerary;
